import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './Components/HomePage';
import GetInvolved from './Components/GetInvolved';
import ClubMembers from './Components/ClubMembers';
import './Components/HomePage.css';
import Merchandise from './Components/Merchandise';
import OurImpact from './Components/OurImpact';
import Gallery from './Components/Gallery';
import SupportSquads from './Components/SupportSquads';
import AboutUs from './Components/AboutUs';
import NavBar from './Components/NavBar';
import ScrollToTop from './Components/ScrollToTop';



const App = () => {
  return (
    <Router>
            <NavBar />   {/* ← sits above all routes */}
<ScrollToTop />  
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route path="/about/operations" element={<AboutUs section="Operations" />} />
        <Route path="/about/origin"     element={<AboutUs section="Origin" />} />
        <Route path="/about/leadership" element={<AboutUs section="Leadership" />} />
<Route path="/our-impact/meals"       element={<OurImpact section="Shared Meals" />} />
<Route path="/our-impact/support"     element={<OurImpact section="Support Teams" />} />
<Route path="/our-impact/testimonies" element={<OurImpact section="Student Testimonies" />} />
<Route path="/our-impact"             element={<OurImpact section="Shared Meals" />} />        <Route path="/get-involved" element={<GetInvolved />} />
        <Route path="/club-members" element={<ClubMembers />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/support-squads" element={<SupportSquads />} />
        <Route path="/merchandise" element={<Merchandise />} />
      </Routes>
    </Router>
  );
};

export default App;